import layoutActions from "actions/layout";
import mapActions from "actions/map";
import modalActions from "actions/modal";
import { connect, generatedActions, viewStateToProps } from "helpers/redux";

const customDispatch = (dispatch) => {
    return {
        clearData: () => dispatch(layoutActions.clearData()),
        modal: (params) => dispatch(modalActions.open(params)),
        switchMap: (params) => dispatch(mapActions.switchMap(params)),
        mergeParams: (params) => dispatch(generatedActions.counterpartypoints.merge(params)),
    };
};

const customState = (state) => viewStateToProps(state, "platon-points");

const customConnect = (Component) => connect(customState, customDispatch)(Component);

export { customConnect };
